exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ant-input[data-v-c7664b28] {\r\n    width: 100%;\n}\n.ant-form-item-label label[data-v-c7664b28]{\r\n    margin-left: 5vw;\n}\n.ant-form-explain[data-v-c7664b28], .ant-form-extra[data-v-c7664b28] {\r\n    margin-left: 5vw;\n}\r\n", ""]);

